export default "__VITE_ASSET__BUIyOPxq__"